<template>
  <page>
    <review-provider
      v-model="review"
      :review-query="GetReviewForUploadsPage"
      subscribe-to-upload-updates
      :load-uploads="true"
      :loading.sync="loading"
      :uploads-loading.sync="uploadsLoading"
      @update:error="redirectToReviewsPage"
    />
    <upload-references-modal :review="review" />
    <template #nav-bar>
      <page-nav-bar :items="breadcrumbs" />
    </template>
    <template #header-bar>
      <page-header-bar>
        <span class="pl-4">Uploads</span>
        <template #actions>
          <div class="d-flex pr-4">
            <action-button color="primary" @click="openUploadModal">
              <v-icon left class="material-icons-outlined">
                cloud_upload
              </v-icon>
              Upload References
            </action-button>
          </div>
        </template>
      </page-header-bar>
    </template>
    <template #content>
      <div class="pa-4 fill-height">
        <uploads-page-skeleton-loader
          v-if="loading || uploadsLoading"
        />
        <div
          v-if="!loading && !uploadsLoading && empty"
          class="d-flex justify-center align-center fill-height"
        >
          <upload-references-page-placeholder />
        </div>
        <upload-group-list
          v-if="review"
          :review-id="review.id"
          :upload-groups="review.uploadGroups()"
          :can-delete="review.currentUserCanEditReview()"
        />
      </div>
    </template>
  </page>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
import Page from '@/components/Common/Page';
import PageNavBar from '@/components/Common/PageNavBar';
import PageHeaderBar from '@/components/Common/PageHeaderBar';
import ReviewProvider from '@/components/Providers/ReviewProvider';
import UploadReferencesModal from '@/components/UploadReferences/UploadReferencesModal';
import UploadsPageSkeletonLoader from '@/components/UploadsPage/UploadsPageSkeletonLoader';
import UploadGroupList from '@/components/UploadsPage/UploadGroupList';
import UploadReferencesPagePlaceholder from '@/components/UploadReferences/UploadReferencesPagePlaceholder';
import { mapActions } from 'vuex';
import { GetReviewForUploadsPage } from '@/graphql';

export default {
  name: 'UploadsPage',
  components: {
    ActionButton,
    Page,
    PageNavBar,
    PageHeaderBar,
    ReviewProvider,
    UploadReferencesModal,
    UploadGroupList,
    UploadsPageSkeletonLoader,
    UploadReferencesPagePlaceholder,
  },
  data: () => ({
    review: null,
    loading: false,
    uploadsLoading: false,
    GetReviewForUploadsPage,
  }),
  computed: {
    breadcrumbs() {
      const breadcrumbs = [
        {
          icon: 'home',
          text: 'Reviews',
          disabled: false,
          href: '/reviews',
          cypressData: 'back-button',
        },
      ];
      if (this.loading) return breadcrumbs;

      return [
        ...breadcrumbs,
        {
          text: this.review?.title,
          href: `/review/${this.review?.id}`,
          disabled: false,
        },
        {
          text: 'Uploads',
          href: `/review/${this.review?.id}/uploads`,
          disabled: true,
        },
      ];
    },
    uploadGroups() {
      return this.review?.uploadGroups();
    },
    empty() {
      return this.uploadGroups?.length === 0;
    },
  },
  methods: {
    ...mapActions({
      openUploadModal: 'uploadReferences/openModal',
    }),
    redirectToReviewsPage() {
      this.$router.push('/reviews');
    },
  },
};
</script>
